import axios from '@/axios.js'
// import axios from 'axios'

export default {
  getBankCashflow (context, payload) {
    return new Promise((resolve, reject) => {
      axios.get('/bank-account-cashflow', { params: {
        bank_account_id: payload.bank_account_id,
        per_page: payload.perPage,
        page: payload.page,
        search: payload.search,
        type: payload.type
      } })
        .then((response) => {
          resolve(response)
        })
        .catch((error) => { reject(error) })
    })
  },
  findBankCashflow (context, id) {
    return new Promise((resolve, reject) => {
      axios.get(`/bank-account-cashflow/${id}`)
        .then((response) => {
          resolve(response)
        })
        .catch((error) => { reject(error) })
    })
  },
  createBankCashflow (context, payload) {
    return new Promise((resolve, reject) => {
      axios.post('/bank-account-cashflow', payload)
        .then((response) => {
          resolve(response)
        })
        .catch((error) => { reject(error) })
    })
  },
  updateBankCashflow (context, payload) {
    return new Promise((resolve, reject) => {
      axios.post(`/bank-account-cashflow/${payload.id}`, payload.data)
        .then((response) => {
          resolve(response)
        })
        .catch((error) => { reject(error) })
    })
  },
  deleteBankCashflow (context, id) {
    return new Promise((resolve, reject) => {
      axios.delete(`/bank-account-cashflow/${id}`)
        .then((response) => {
          resolve(response)
        })
        .catch((error) => { reject(error) })
    })
  }
}
